// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"skeleton_wrapper__2BO4_","shine":"skeleton_shine__1wN3d"};